import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import kebabCase from "lodash/kebabCase";
import PropTypes from "prop-types";
import { makeGetAllAttachmentsByParent } from "~/store/selectors/selector.attachments";
import Angie from "~/utils/angie";
import { AttachmentList } from "../attachments/AttachmentList";
import { useFilePreviewContext } from "../FilePreview";

export const Attachments = ({ type, id, className }) => {
  const { openFilePreview } = useFilePreviewContext();
  const getAllObjectAttachments = useMemo(() => {
    return makeGetAllAttachmentsByParent({
      parentType: type,
      parentId: id,
    });
  }, [type, id]);

  const attachments = useSelector(getAllObjectAttachments);

  const filteredAttachments = useMemo(
    () => attachments.filter((attachment) => attachment.disposition === "attachment"),
    [attachments]
  );

  const downloadAllUrl = `${Angie.api_url}/attachments/${kebabCase(type)}/${id}/download`;

  const handleOpenFilePreview = useCallback(
    (id) => {
      openFilePreview(id, attachments);
    },
    [attachments, openFilePreview]
  );

  if (filteredAttachments.length <= 0) return null;

  return (
    <AttachmentList
      items={filteredAttachments}
      downloadAllUrl={downloadAllUrl}
      onItemClick={handleOpenFilePreview}
      className={className}
    />
  );
};

Attachments.propTypes = {
  type: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  className: PropTypes.string,
};
